import { callT } from '~/utils/callI18n';
import { isCocCocBrowser } from '~/utils/browser';

export function getJanusWebSocketErrorMessage(translate?: (key: string) => string): string {
  const key = isCocCocBrowser() ? 'errors.janusWsBlockedCocCoc' : 'errors.janusWsBlocked';
  return callT(key, translate);
}

export function resolveConnectJanusErrorMessage(
  err: unknown,
  translate: (key: string) => string
): string {
  const errMsg = (err instanceof Error ? err.message : String(err)).trim();
  if (errMsg.length > 12) return errMsg;
  return getJanusWebSocketErrorMessage(translate);
}
